module.exports = __webpack_public_path__ + "774b69dc7e7876f9c44f753b85d03cda.png";